import React from 'react';
import { createPortal } from 'react-dom';
import { formatEndDate } from './OfferCountdown';

export const PrintableCoupon = ({ special }) => createPortal(
  <div className="print-coupon" data-testid="printable-coupon">
    <div style={{ border: '3px dashed #059669', borderRadius: 16, padding: 32, fontFamily: 'DM Sans, sans-serif', color: '#0f172a' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <img src="/images/assets/old-logo.jpg" alt="ComfortMaster Heating & Air" style={{ height: 60 }} />
        <span style={{ background: '#059669', color: '#fff', fontWeight: 800, padding: '6px 14px', borderRadius: 999 }}>{special.badge}</span>
      </div>
      <h1 style={{ fontFamily: 'Barlow Condensed, sans-serif', fontSize: 44, fontWeight: 800, textTransform: 'uppercase', margin: '0 0 8px' }}>{special.title}</h1>
      <p style={{ fontSize: 16, margin: '0 0 16px' }}>{special.description}</p>
      {special.price !== '0' && (
        <p style={{ fontSize: 36, fontWeight: 800, margin: '0 0 12px' }}>
          ${special.price} {special.regularPrice && <span style={{ fontSize: 18, color: '#64748b', textDecoration: 'line-through' }}>${special.regularPrice}</span>}
        </p>
      )}
      <ul style={{ margin: '0 0 16px', paddingLeft: 20, fontSize: 14 }}>
        {special.includes.map(i => <li key={i}>{i}</li>)}
      </ul>
      {special.code && <p style={{ fontSize: 18, margin: '0 0 12px' }}>Promo code: <strong style={{ fontFamily: 'monospace' }}>{special.code}</strong></p>}
      <p style={{ fontSize: 16, fontWeight: 700, margin: '0 0 16px' }}>Expires {formatEndDate(special.validUntil)}</p>
      <p style={{ fontSize: 11, color: '#475569', margin: '0 0 20px' }}>{special.finePrint}</p>
      <div style={{ borderTop: '1px solid #cbd5e1', paddingTop: 12, fontSize: 14, display: 'flex', justifyContent: 'space-between' }}>
        <span><strong>Call (859) 357-6803</strong> · comfortmasterheating.com</span>
        <span>Present this coupon to your technician</span>
      </div>
    </div>
  </div>,
  document.body
);
